"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCalculateDistancesDto = instanceOfCalculateDistancesDto;
exports.CalculateDistancesDtoFromJSON = CalculateDistancesDtoFromJSON;
exports.CalculateDistancesDtoFromJSONTyped = CalculateDistancesDtoFromJSONTyped;
exports.CalculateDistancesDtoToJSON = CalculateDistancesDtoToJSON;
exports.CalculateDistancesDtoToJSONTyped = CalculateDistancesDtoToJSONTyped;
const OriginDestinationPairDto_1 = require("./OriginDestinationPairDto");
/**
 * Check if a given object implements the CalculateDistancesDto interface.
 */
function instanceOfCalculateDistancesDto(value) {
    if (!('pairs' in value) || value['pairs'] === undefined)
        return false;
    return true;
}
function CalculateDistancesDtoFromJSON(json) {
    return CalculateDistancesDtoFromJSONTyped(json, false);
}
function CalculateDistancesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pairs': (json['pairs'].map(OriginDestinationPairDto_1.OriginDestinationPairDtoFromJSON)),
    };
}
function CalculateDistancesDtoToJSON(json) {
    return CalculateDistancesDtoToJSONTyped(json, false);
}
function CalculateDistancesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pairs': (value['pairs'].map(OriginDestinationPairDto_1.OriginDestinationPairDtoToJSON)),
    };
}
//# sourceMappingURL=CalculateDistancesDto.js.map